import { defineComponent as _defineComponent } from 'vue'
import {
  computed, PropType, ref, watch
} from 'vue';
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import { Chat, ChatGroupMember } from '@/models/Messenger';
import useMessengerState from '@/state/messenger/messengerState';
import MessengerGroupService from '@/services/MessengerGroupService';
import store from '@/store';
import SettingsIcon from '@/components/svg/settings_2.svg?inline';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerChatGroupConversationHeader',
  props: {
  chat: {
    type: Object as PropType<Chat>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const MAX_AVATARS = 8;

const { chatgroups, openChatgroupPanel } = useMessengerState();

const group = computed(() => chatgroups.value.find((g) => g.groupId === props.chat.id));
const name = computed(() => group.value?.title ?? '');
const isGroupAdmin = computed(() => group.value?.creator === store.getters.user?.userId);

const members = ref<ChatGroupMember[]>([]);
const loadMembers = async () => {
  const g = group.value;
  if (!g) {
    members.value = [];
    return;
  }
  members.value = (await MessengerGroupService.getMembers(g.groupId)).filter((m) => m.state === 'ACTIVE');
};
// Reload when the group changes or its active-member count does (join/leave).
watch(() => `${group.value?.groupId}:${group.value?.memberCount ?? ''}`, loadMembers, { immediate: true });

const isOnline = (userId?: string) => {
  if (!userId) return false;
  const info = store.getters['userStates/getUserInfo'](userId);
  return !!(info?.isOnline || info?.online);
};

const loadOnlineStatus = () => members.value.forEach((member) => {
  if (!member.user) return;
  store.getters['userStates/getUserInfo'](member.user); // inits + loads cached info
  store.dispatch('userStates/requestOnlineStatus', member.user); // refreshes the online flag
});
watch(members, loadOnlineStatus, { immediate: true });

// Online members first (stable otherwise), capped at MAX_AVATARS; the rest as +nn.
const membersSorted = computed(() => [...members.value]
  .sort((a, b) => Number(isOnline(b.user)) - Number(isOnline(a.user))));
const shownMembers = computed(() => membersSorted.value.slice(0, MAX_AVATARS));
const overflow = computed(() => Math.max(0, members.value.length - MAX_AVATARS));

const openDetails = () => openChatgroupPanel(props.chat.id);

return { __sfc: true,props, MAX_AVATARS, chatgroups, openChatgroupPanel, group, name, isGroupAdmin, members, loadMembers, isOnline, loadOnlineStatus, membersSorted, shownMembers, overflow, openDetails, BCXAvatar, SettingsIcon }
}

})